//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';

//theme
import { HeaderPage1 } from 'theme/elements/Headers';

export default function CreateHeader() {
	const t = useAppSelector(selectTranslations);
	return <HeaderPage1 title={t('page.pay.create.header.title')} text={t('page.pay.create.header.text')} />;
}
